<template>
  <SelectExpertApply-form :id="id"/>
</template>

<script>

import SelectExpertApplyForm from '@/epp/expertmain/selectexpertapply/common/SelectExpertApplyForm'

export default {
  name: 'SelectExpertApplyEdit',
  components: {
    SelectExpertApplyForm
  },
  data () {
    return {
      id: this.$route.query.id
    }
  },
  computed: {},
  created () {
  },
  methods: {}
}
</script>

<style></style>
